import {AfriexVerificationStatus} from '@afriex/core/domain/enums';

export {AfriexVerificationStatus} from '@afriex/core/domain/enums';

export const kycDisplayStatuses = [
  {key: 'Verified', value: AfriexVerificationStatus.Success},
  {key: 'Pending', value: AfriexVerificationStatus.Pending},
  {key: 'Failed', value: AfriexVerificationStatus.Failed},
  {key: 'Not Started', value: AfriexVerificationStatus.NotStarted},
  {
    key: 'Reupload Requested',
    value: AfriexVerificationStatus.ReuploadRequested,
  },
];
